import Chart from 'chart.js/auto';
// turbo load help us to not full page reload but the specific content refresh whenever we visit that page
document.addEventListener("turbo:load", () => {
  // Sales Chart (line chart)
  const salesChartEl = document.getElementById('salesChart');
  if (salesChartEl) {
    const salesCtx = salesChartEl.getContext('2d');
    new Chart(salesCtx, {
      type: 'line',
      data: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        datasets: [{
          label: 'Sales',
          data: [10, 20, 15, 30, 40, 35, 50],
          borderColor: 'rgba(60,141,188,0.8)',
          backgroundColor: 'rgba(60,141,188,0.4)',
          fill: true,
          tension: 0.4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    });
  }

  // Pie Chart (doughnut chart)
  const pieChartEl = document.getElementById('pieChart');
  if (pieChartEl) {
    const pieCtx = pieChartEl.getContext('2d');
    const data = {
      labels: ['Chrome', 'IE', 'FireFox', 'Safari', 'Opera', 'Navigator'],
      datasets: [{
        data: [40, 20, 15, 10, 10, 5],
        backgroundColor: [
          '#f56954', // Chrome - red
          '#00a65a', // IE - green
          '#f39c12', // FireFox - yellow
          '#00c0ef', // Safari - aqua
          '#3c8dbc', // Opera - blue
          '#d2d6de'  // Navigator - grey
        ]
      }]
    };
    const options = {
      maintainAspectRatio: false,
      responsive: true,
      cutout: '60%'
    };
    new Chart(pieCtx, {
      type: 'doughnut',
      data: data,
      options: options
    });
  }
});
